import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CloseIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" strokeWidth="1.5" {...props}>
            <path
                d="M15 5L5 15"
                stroke="currentColor"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 5L15 15"
                stroke="currentColor"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
